module.exports = __webpack_public_path__ + "static/comscore-d6a8d9742c0179cf55b5afde84823246.svg";